import React from 'react'
import { Tooltip } from 'react-tooltip'

import ReportTable from '../report_table'
import { formatReportDate, getCountUpCell, localeNumberFormatter } from '../helpers'

// port of cowebapp analytics/components/email_verifier/report_individual_table.js
const ReportTableIndividual = (props) => {

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.userReportData.breakdown)
  }

  const bounceFormatter = (cell) => {
    if (cell != 0) {
      return getCountUpCell(cell, { precision: 0, suffix: '%' })
    } else {
      return '-'
    }
  }

  const estCostFormatter = (cell) => {
    if (cell != 0) {
      const title = cell > 999 ? Number(cell).toFixed(2).toLocaleString() : ''
      return getCountUpCell(cell, { precision: 2, prefix: '$', title })
    } else {
      return '-'
    }
  }

  const getStsColor = (cell) => {
    if (cell < 5) {
      return 'rgba(254, 27, 27, 0.63)'
    } else if (cell < 15 && cell >= 5) {
      return 'rgba(248, 98, 22, 0.61)'
    } else if (cell < 50 && cell >= 15) {
      return 'rgba(255, 211, 15, 0.56)'
    } else if (cell < 80 && cell >= 50) {
      return 'rgba(0, 246, 255, 0.56)'
    } else {
      return 'rgba(0, 255, 111, 0.56)'
    }
  }

  const getStsTitle = (cell) => {
    if (cell < 5) {
      return 'Extermely Low Deliverabilities'
    } else if (cell < 15 && cell >= 5) {
      return 'Low Deliverabilities'
    } else if (cell < 50 && cell >= 15) {
      return 'Moderate Deliverabilities'
    } else if (cell < 80 && cell >= 50) {
      return 'High Deliverabilities'
    } else {
      return 'Extermely High Deliverabilities'
    }
  }

  const safeToSendFormatter = (cell, row) => {
    if (cell != 0) {
      let backgroundColor = getStsColor(cell)
      let title = getStsTitle(cell)
      let width = cell + '%'
      return (
        <div data-tooltip-id={`sts-${row.date}`}>
          <div
            className="stat-value sts"
            style={{ backgroundColor: backgroundColor, width: width, marginBottom: '0px', paddingLeft: '5px' }}
          >
            {getCountUpCell(cell, { precision: 0, suffix: '%' })}
            <Tooltip id={`sts-${row.date}`}>{title}</Tooltip>
          </div>
        </div>
      )
    } else {
      return (
        <div style={{ textAlign: 'right' }}>
          {'-'}
        </div>
      )
    }
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []
    let tmp = props.tableData && props.tableData[0] && props.tableData[0].stats ?
      props.tableData[0].stats : props.tableData
    tmp.forEach((data) => {
      if (data.total > 0) {
        tableData.push(data)
      }
    })

    return tableData
  }

  const data = getTableData()
  const formatNumber = localeNumberFormatter('0')

  const columns = [
    {
      dataField: 'date',
      text: 'Day',
      formatter: dateFormatter,
      headerStyle: { width: '19%' },
      style: { width: '19%' },
    },
    {
      dataField: 'total',
      text: 'Total Verified',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Total Verified includes Duplicate'
    },
    {
      dataField: 'bounce_detected',
      text: 'Bounce Detected',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: bounceFormatter,
      align: 'right',
      sort: true
    },
    {
      dataField: 'cost_saved',
      text: 'Est. Cost Saved (USD)',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: estCostFormatter,
      align: 'right',
      sort: true
    },
    {
      dataField: 'safe_to_send',
      text: 'Safe to Send',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: safeToSendFormatter,
      sort: true
    },
    {
      dataField: 'valid',
      text: 'Valid',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'invalid',
      text: 'Invalid',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'catch_all',
      text: 'Catch All',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'unknown',
      text: 'Unknown',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'billable',
      text: 'Billable Credits',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  return (
    <div className="report-table">
      <ReportTable
        keyField="date"
        data={data}
        columns={columns}
        wrapperClasses="table-report table-responsive"
        noDataIndication={noDataIndication}
      />
    </div>
  )
}

export default ReportTableIndividual
